import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/NavBar'; // Importamos la NavBar
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutUs from '../components/AboutUs';
import GoogleReviews from '../components/GoogleReviews';
import fleetImage from '../assets/images/jetblack-bg.png';
import mapImage from '../assets/images/service_map.png';

const servicesData = [
  {
    image: require('../assets/images/sprinter_service.png'),
    title: 'Airport Transfer',
    subtitle: 'Services',
    description:
      'Reliable, timely, and comfortable transfers to and from major airports, ensuring a stress-free travel experience.',
  },
  {
    image: require('../assets/images/escalade_service.png'),
    title: 'Corporate Events Transportation',
    description:
      'Reliable and punctual service tailored for business meetings, conferences, and corporate gatherings.',
  },
  {
    image: require('../assets/images/lincoln_transfer.png'),
    title: 'Point to Point Transfer Service',
    description:
      'Enjoy seamless, timely transfers between locations with our comfortable point-to-point service.',
  },
];

function HomeScreen() {
  const [showServices, setShowServices] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detecta si es móvil basándose en el userAgent
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(
        /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      );
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Observer para la sección de servicios
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowServices(true);
        }
      },
      { threshold: 0.3 }
    );
    const section = document.querySelector('#servicesSection');
    if (section) observer.observe(section);
    return () => observer.disconnect();
  }, []);

  // Lógica para evitar renderizar dos veces el Footer.
  let footerJSX = null;
  if (!window.footerHasRendered) {
    window.footerHasRendered = true;
    footerJSX = <Footer />;
  }

  return (
    <div style={styles.pageContainer}>
      {/* Importamos y mostramos la NavBar en la parte superior */}
      <NavBar />

      <Header />

      <main style={styles.contentContainer}>
        {/* Sección Hero para escritorio */}
        {!isMobile && (
          <section style={styles.heroSection}>
            <div style={styles.heroOverlay}></div>
            <div style={styles.heroContent}>
              <h1 style={styles.heroTitle}>Our Luxury Fleet</h1>
              <p style={styles.heroSubtitle}>Experience unmatched comfort and style</p>
            </div>
          </section>
        )}

        <div style={styles.whiteStripe}></div>

        {/* Sección AboutUs */}
        {!isMobile && (
          <section style={styles.aboutSection}>
            <AboutUs />
          </section>
        )}

        {/* Sección de Servicios (texto descriptivo) */}
        <section
          id="servicesSection"
          style={{
            ...styles.servicesSection,
            opacity: showServices ? 1 : 0,
            transform: showServices ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 0.8s ease, transform 0.8s ease',
          }}
        >
          <h4 style={styles.sectionTitle}>
            <span style={styles.ourText}>OUR</span> <span style={styles.ourText}>SERVICES</span>
          </h4>
          <h1 style={styles.mainHeading}>
            We Provide Luxury Limousine and Car Service in Westchester County, Dutchess County, Putnam County,
            Orange County, and Fairfield County
          </h1>

          <p style={styles.compactParagraph}>
            Jet Black Limo specializes in providing luxury transportation services across the region of New York,
            covering key cities and towns, ensuring comfortable and safe travel.
          </p>
          <p style={styles.compactParagraph}>
            We offer efficient transfers to and from major nearby airports, including JFK, LaGuardia (LGA),
            Newark (EWR), Westchester County Airport (HPN), Bradley Airport, New York City, and other key locations.
          </p>
          <p style={styles.compactParagraph}>
            Our fleet of luxury vehicles, combined with professional chauffeurs, ensures punctual service for events,
            corporate meetings, weddings, and long-distance travel.
          </p>
        </section>

        {/* Tarjetas de Servicios */}
        <section style={styles.cardsContainer}>
          {servicesData.map((service, index) => (
            <div
              key={index}
              style={styles.card}
              onMouseEnter={(e) =>
                (e.currentTarget.querySelector('img').style.transform = 'scale(1.05)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.querySelector('img').style.transform = 'scale(1)')
              }
            >
              <div style={styles.imageWrapperCard}>
                <img src={service.image} alt={service.title} style={styles.cardImage} />
              </div>
              <h2 style={styles.cardTitle}>{service.title}</h2>
              {service.subtitle && <h3 style={styles.subtitle}>{service.subtitle}</h3>}
              <p
                style={
                  index === 0
                    ? { ...styles.cardDescription, marginTop: '-10px' }
                    : styles.cardDescription
                }
              >
                {service.description}
              </p>
              {/* Botón "Read More" redirige a la página de Fleet */}
              <Link
                to="/fleet"
                style={styles.cardButton}
                onMouseEnter={(e) => {
                  e.currentTarget.querySelector('.arrow').style.marginLeft = '15px';
                  e.currentTarget.style.backgroundColor = '#000';
                  e.currentTarget.style.color = '#fff';
                  e.currentTarget.style.padding = '15px 50px';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.querySelector('.arrow').style.marginLeft = '8px';
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.color = '#2F3A4A';
                  e.currentTarget.style.padding = '15px 40px';
                }}
              >
                Read More <span className="arrow" style={styles.arrow}>→</span>
              </Link>
            </div>
          ))}
        </section>

        {/* Sección de Mapa y OUR COMPANY */}
        {!isMobile && (
          <section style={{ ...styles.mapSection, display: 'flex' }}>
            <div style={styles.mapContent}>
              <div style={styles.leftContent}>
                <h2 style={styles.mapTitle}>OUR COMPANY</h2>
                <p style={styles.mapDescription}>Established in 2025</p>
                <p style={styles.mapDescription}>
                  Hire the Best Limousine and Luxury Car Service in Westchester County
                </p>
                <h3 style={styles.mapHeading}>
                  Jet Black Limo provides reliable, 24-hour luxury transportation with point-to-point
                  services. Covering key areas such as Westchester County, Dutchess County, Putnam County,
                  Orange County, and Fairfield County, our diverse fleet ensures your travel is
                  safe and on time.
                </h3>
                <p style={styles.mapDescription}>
                  Our services extend to efficient airport transfers at JFK, LaGuardia (LGA), Newark (EWR),
                  Westchester County Airport (HPN), Bradley Airport, and key destinations, including New York City.
                </p>
                <p style={styles.mapDescription}>
                  Whether it’s corporate meetings, events, weddings, or long-distance trips, our
                  professional chauffeurs and luxurious fleet guarantee unmatched service and comfort.
                </p>
              </div>
              <div style={styles.rightContent}>
                <img
                  src={mapImage}
                  alt="Service Coverage Map"
                  style={{
                    ...styles.mapImage,
                    backgroundColor: '#1E2A38',
                    width: '80%',
                    height: '400px',
                    objectFit: 'cover',
                    transition: 'all 0.3s ease',
                  }}
                />
              </div>
            </div>
          </section>
        )}

        <GoogleReviews />

        <div style={styles.midWhiteStripe}></div>
      </main>

      {/* Renderizamos el Footer solo si aún no se ha renderizado */}
      {footerJSX}
    </div>
  );
}

const styles = {
  pageContainer: {
    backgroundColor: '#ffffff',
    color: '#000',
    fontFamily: "'Merriweather', serif",
    margin: 0,
    padding: 0,
    overflowX: 'hidden',
  },
  contentContainer: {
    width: '100%',
    margin: '0 auto',
    padding: '0',
  },
  // Sección Hero
  heroSection: {
    position: 'relative',
    width: '100%',
    height: '450px',
    backgroundImage: `url(${fleetImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '30px',
    color: '#fff',
  },
  heroOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 0,
  },
  heroContent: {
    position: 'relative',
    zIndex: 1,
    textAlign: 'left',
  },
  heroTitle: {
    fontSize: '3rem',
    margin: 0,
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.6)',
  },
  heroSubtitle: {
    fontSize: '1.8rem',
    margin: '15px 0 0',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.6)',
  },
  whiteStripe: {
    width: '100%',
    height: '30px',
    backgroundColor: '#ffffff',
    marginBottom: '5px',
  },
  // Sección AboutUs (botones y descripción)
  aboutSection: {
    background: 'linear-gradient(to bottom, #f7f8fa 75%, #ffffff 25%)',
    padding: '80px 25px',
  },
  aboutUsContainer: {
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto',
  },
  aboutText: {
    fontSize: '18px',
    lineHeight: '1.6',
    color: '#6C757D',
    marginBottom: '30px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
  },
  reservationButton: {
    textDecoration: 'none',
    backgroundColor: '#0d2b3e',
    color: '#fff',
    padding: '15px 40px',
    borderRadius: '10px',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    transition: 'background-color 0.3s ease',
  },
  callButton: {
    textDecoration: 'none',
    backgroundColor: '#ffffff',
    color: '#2F3A4A',
    padding: '15px 40px',
    borderRadius: '10px',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    border: '1px solid #0d2b3e',
    transition: 'background-color 0.3s ease',
  },
  // Sección de Servicios (texto descriptivo)
  servicesSection: {
    padding: '40px 20px',
    backgroundColor: '#ffffff',
    maxWidth: '1000px',
    margin: '0 auto',
    textAlign: 'center',
  },
  sectionTitle: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    fontSize: '36px',
    fontWeight: '900',
    fontFamily: "'Playfair Display', serif",
  },
  ourText: {
    color: '#000',
    fontSize: '38px',
    fontWeight: '900',
    textShadow: '3px 3px 8px rgba(0, 0, 0, 0.5)',
  },
  mainHeading: {
    color: '#2F3A4A',
    fontSize: '28px',
    fontWeight: '600',
    fontFamily: "'Playfair Display', serif",
    margin: '10px 0',
  },
  compactParagraph: {
    color: '#6C757D',
    fontSize: '18px',
    lineHeight: '1.6',
    fontFamily: "'Merriweather', serif",
    maxWidth: '1000px',
    margin: '0 auto',
  },
  // Tarjetas de Servicios
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '30px',
    padding: '50px 20px',
  },
  card: {
    width: '300px',
    border: '1px solid #e0e0e0',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    backgroundColor: '#ffffff',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  imageWrapperCard: {
    overflow: 'hidden',
    borderRadius: '8px',
  },
  cardImage: {
    width: '100%',
    borderRadius: '8px',
    transition: 'transform 0.4s ease',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontFamily: "'Playfair Display', serif",
    color: '#2F3A4A',
    margin: '5px 0',
  },
  subtitle: {
    fontSize: '1.5rem',
    fontFamily: "'Playfair Display', serif",
    color: '#2F3A4A',
    marginTop: '-5px',
  },
  cardDescription: {
    fontSize: '1rem',
    fontFamily: "'Merriweather', serif",
    color: '#6C757D',
    lineHeight: '1.6',
    marginBottom: '20px',
    minHeight: '90px',
  },
  cardButton: {
    textDecoration: 'none',
    backgroundColor: '#ffffff',
    color: '#2F3A4A',
    padding: '15px 40px',
    borderRadius: '10px',
    fontWeight: 'bold',
    fontSize: '1rem',
    display: 'inline-block',
    textAlign: 'center',
    cursor: 'pointer',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
    transition: 'background-color 0.3s ease, color 0.3s ease, padding 0.3s ease',
  },
  arrow: {
    fontSize: '1.5rem',
    marginLeft: '8px',
    transition: 'margin-left 0.3s ease',
  },
  // Sección de Mapa y OUR COMPANY
  mapSection: {
    width: '100%',
    padding: '30px 15px',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#1E2A38',
  },
  mapContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  leftContent: {
    width: '40%',
    padding: '0 20px',
  },
  mapTitle: {
    fontSize: '30px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#ffffff',
  },
  mapHeading: {
    fontSize: '22px',
    color: '#ffffff',
    marginBottom: '10px',
  },
  mapDescription: {
    fontSize: '16px',
    lineHeight: '1.5',
    color: '#D1D5DB',
  },
  rightContent: {
    width: '55%',
  },
  mapImage: {
    borderRadius: '8px',
  },
  midWhiteStripe: {
    width: '100%',
    height: '80px',
    backgroundColor: '#ffffff',
    marginTop: '0px',
    marginBottom: '100px',
  },
};

export default HomeScreen;
